import {
  coreExtensionData,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';
import adoptionAnalyticsPlugin from '@codeverse-gp/plugin-adoption-analytics';
import styles from './adoption-analytics-plugin.module.css';

/** Wraps the original Adoption Analytics page in a scoped container for custom styling. */
const adoptionAnalyticsPageOverride = adoptionAnalyticsPlugin
  .getExtension('page:adoption-analytics')
  .override({
    factory(originalFactory) {
      const originalOutput = originalFactory({ params: { noHeader: true } });
      const originalElement = originalOutput.get(
        coreExtensionData.reactElement,
      );

      return [
        ...[...originalOutput].filter(
          data => data.id !== coreExtensionData.reactElement.id,
        ),
        coreExtensionData.reactElement(
          <div className={styles.root}>{originalElement}</div>,
        ),
      ];
    },
  });

/** Bundles all DevTools overrides into a single frontend module. */
export const adoptionAnalyticsPluginOverride = createFrontendModule({
  pluginId: 'adoption-analytics',
  extensions: [adoptionAnalyticsPageOverride],
});
